/* tslint:disable */
/* eslint-disable */
/**
 * crm
 * crm
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LatestAPFMUpdatesResponse } from './LatestAPFMUpdatesResponse';
import {
    LatestAPFMUpdatesResponseFromJSON,
    LatestAPFMUpdatesResponseFromJSONTyped,
    LatestAPFMUpdatesResponseToJSON,
} from './LatestAPFMUpdatesResponse';

/**
 * 
 * @export
 * @interface FindLatestAPFMUpdates200Response
 */
export interface FindLatestAPFMUpdates200Response {
    /**
     * 
     * @type {LatestAPFMUpdatesResponse}
     * @memberof FindLatestAPFMUpdates200Response
     */
    data?: LatestAPFMUpdatesResponse;
}

/**
 * Check if a given object implements the FindLatestAPFMUpdates200Response interface.
 */
export function instanceOfFindLatestAPFMUpdates200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindLatestAPFMUpdates200ResponseFromJSON(json: any): FindLatestAPFMUpdates200Response {
    return FindLatestAPFMUpdates200ResponseFromJSONTyped(json, false);
}

export function FindLatestAPFMUpdates200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindLatestAPFMUpdates200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : LatestAPFMUpdatesResponseFromJSON(json['data']),
    };
}

export function FindLatestAPFMUpdates200ResponseToJSON(value?: FindLatestAPFMUpdates200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': LatestAPFMUpdatesResponseToJSON(value.data),
    };
}

